import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen pt-[160px]">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#041230] to-[#032744] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">
            About Chola Realtors
          </h1>
          <p className="text-xl text-center max-w-2xl mx-auto">
            Your trusted partner in real estate for over a decade
          </p>
        </div>
      </div>

      {/* Our Story */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Our Story
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Founded in 2010, Chola Realtors has been at the forefront of the real estate industry, 
                helping thousands of families find their perfect homes and investors build their portfolios.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Our commitment to excellence, integrity, and personalized service has made us one of the 
                most trusted names in real estate. We believe that buying or selling a home should be an 
                exciting and rewarding experience.
              </p>
              <p className="text-lg text-gray-600">
                With deep market knowledge and cutting-edge technology, we provide our clients with the 
                insights and tools they need to make informed decisions in today's dynamic real estate market.
              </p>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Our office"
                className="rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-primary-600 mb-2">1000+</div>
              <div className="text-gray-600">Properties Sold</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary-600 mb-2">500+</div>
              <div className="text-gray-600">Happy Families</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary-600 mb-2">15+</div>
              <div className="text-gray-600">Years Experience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary-600 mb-2">50+</div>
              <div className="text-gray-600">Expert Agents</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;